import React, { SVGProps } from 'react'
const SvgReimbursementsNeedReview = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <rect width="20" height="20" rx="10" fill="black" />
    <path
      d="M14.1775 8.76856L8.53418 14.2686C8.47816 14.3232 8.40685 14.3585 8.3305 14.3705L8.27245 14.375H6.5C6.31015 14.375 6.15325 14.2339 6.12842 14.0509L6.125 14V12.2276C6.125 12.1493 6.14945 12.0736 6.19417 12.0106L6.23145 11.9658L11.7315 6.32256L12.6697 5.38426C12.9951 5.05891 13.5096 5.03978 13.8572 5.32685L13.9203 5.38426L15.1158 6.57966C15.4411 6.905 15.4602 7.41956 15.1732 7.76716L15.1158 7.83029L14.1775 8.76856ZM12.0035 7.118L6.875 12.3795V13.625H8.1195L13.3815 8.496L12.0035 7.118ZM13.39 5.91459C13.346 5.8706 13.2801 5.86327 13.2288 5.8926L13.2 5.91459L12.5305 6.584L13.9155 7.9695L14.5854 7.29996C14.6206 7.26478 14.6323 7.21553 14.6206 7.17097L14.6074 7.13873L14.5854 7.11L13.39 5.91459Z"
      fill="white"
    />
  </svg>
)
export default SvgReimbursementsNeedReview
